module.exports = __webpack_public_path__ + "static/driver-ef00a63c58daf9803f2af55517a5c11e.png";